function crc32(bytes) {
  let crc = 0xffffffff;
  for (let i = 0; i < bytes.length; i += 1) {
    crc ^= bytes[i];
    for (let bit = 0; bit < 8; bit += 1) {
      crc = (crc >>> 1) ^ (crc & 1 ? 0xedb88320 : 0);
    }
  }
  return (crc ^ 0xffffffff) >>> 0;
}

function u16(view, offset, value) {
  view.setUint16(offset, value, true);
}

function u32(view, offset, value) {
  view.setUint32(offset, value, true);
}

/** ZIP sem compressão. Cada arquivo entra com o caminho informado. */
export function zipStore(arquivos) {
  const encoder = new TextEncoder();
  const locais = [];
  const centrais = [];
  let offset = 0;

  arquivos.forEach((arquivo) => {
    const nome = encoder.encode(arquivo.nome);
    const dados = arquivo.dados;
    const crc = crc32(dados);
    const local = new Uint8Array(30 + nome.length);
    const lv = new DataView(local.buffer);
    u32(lv, 0, 0x04034b50);
    u16(lv, 4, 20);
    u16(lv, 6, 0);
    u16(lv, 8, 0);
    u16(lv, 10, 0);
    u16(lv, 12, 0);
    u32(lv, 14, crc);
    u32(lv, 18, dados.length);
    u32(lv, 22, dados.length);
    u16(lv, 26, nome.length);
    u16(lv, 28, 0);
    local.set(nome, 30);

    const central = new Uint8Array(46 + nome.length);
    const cv = new DataView(central.buffer);
    u32(cv, 0, 0x02014b50);
    u16(cv, 4, 20);
    u16(cv, 6, 20);
    u16(cv, 8, 0);
    u16(cv, 10, 0);
    u16(cv, 12, 0);
    u16(cv, 14, 0);
    u32(cv, 16, crc);
    u32(cv, 20, dados.length);
    u32(cv, 24, dados.length);
    u16(cv, 28, nome.length);
    u16(cv, 30, 0);
    u16(cv, 32, 0);
    u16(cv, 34, 0);
    u16(cv, 36, 0);
    u32(cv, 38, 0);
    u32(cv, 42, offset);
    central.set(nome, 46);

    locais.push(local, dados);
    centrais.push(central);
    offset += local.length + dados.length;
  });

  const centralInicio = offset;
  const centralTamanho = centrais.reduce((soma, parte) => soma + parte.length, 0);
  const fim = new Uint8Array(22);
  const fv = new DataView(fim.buffer);
  u32(fv, 0, 0x06054b50);
  u16(fv, 4, 0);
  u16(fv, 6, 0);
  u16(fv, 8, arquivos.length);
  u16(fv, 10, arquivos.length);
  u32(fv, 12, centralTamanho);
  u32(fv, 16, centralInicio);
  u16(fv, 20, 0);

  const blob = new Blob([...locais, ...centrais, fim], { type: 'application/zip' });
  return blob;
}

export function baixarBlob(blob, nome) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
